export function NextStepsSection(): React.ReactElement {
  return (
    <div className="w-full max-w-[479px] rounded-[20px] border border-zinc-200 bg-zinc-100 shadow-[0px_4px_6px_-3px_rgba(0,0,0,0.1)]">
      <div className="px-[30px] py-[10px]">
        <p className="text-[14px] font-medium leading-[20px] text-zinc-500">
          Next steps after connecting
        </p>
      </div>
      <div className="rounded-[20px] border border-zinc-200 bg-zinc-50 p-[30px]">
        <div className="flex flex-col gap-[20px]">
          <div className="flex flex-col gap-[5px]">
            <p className="text-[16px] font-medium leading-[20px] text-zinc-700">
              1. Head to any of the above Dapps
            </p>
            <p className="pl-[31px] text-[12px] font-normal leading-[20px] text-zinc-500">
              Don&apos;t close this page!
            </p>
          </div>
          <p className="text-[16px] font-medium leading-[20px] text-zinc-700">
            2. Queue a transaction in the Dapp
          </p>
          <p className="text-[16px] font-medium leading-[20px] text-zinc-700">
            3. Come back here to submit it
          </p>
        </div>
      </div>
    </div>
  );
}
